import type { DocumentNode } from 'graphql';
import getDocumentKey from '@app/data/edge/utils/getDocumentKey';
import client, { clientOptions } from '../client';

type options = {
  clientOptions?: clientOptions;
  context?: {
    headers?: { [x: string]: string };
  };
};

/**
 *
 * @param queryKey
 * @param query
 * @param options
 * @constructor
 */
const fetchEdge = async <T = unknown>(
  { queryKey },
  query: DocumentNode,
  options: options = {},
) => {
  const { context: { headers = {} } = {} } = options;
  const edgeClient = client(options?.clientOptions ?? {});
  const [, { variables }] = queryKey;
  return edgeClient.request<T>(query, variables, {
    ...headers,
    'x-operation-name': getDocumentKey(query),
  });
};

export default fetchEdge;
